import React from 'react'
import Pagination from '../../../../Components/Utils/Pagenation'
import IncomingCard from './IncomingCard'

function IndexMobileIncoming({data,total,getData,pageIndex,setPageIndex,dataCount,setDataCount}) {
    return (
      <div className=' w-full h-[calc(100vh-160px)]'>
         <div className=' w-full h-[calc(100vh-199px)] overflow-y-auto py-1 px-2'>
          {
              data && data.map((item,index)=>{
                  return(
                      <IncomingCard item={item}         getData={getData}
                      key={index}/>
                  )
              })
          }
          </div> 
         <div className=' w-full h-8'>
                  <Pagination
                    total={total}
                    pageIndex={pageIndex}
                    setPageIndex={setPageIndex}
                    dataCount={dataCount}
                    setDataCount={setDataCount}
                  />
          </div> 
      </div>
    )
  }


export default IndexMobileIncoming